// ── Affiliate links list ──────────────────────────────────────────────────
export const linksKeys = {
  all: ["affiliate-links"],
  list: (params) => [...linksKeys.all, "list", params],
  aggregation: (search) => [...linksKeys.all, "aggregation", search],
};

// ── "Show affiliate link" detail tabs ─────────────────────────────────────
export const affiliateLinkDetailsKeys = {
  all: ["affiliate-link-details"],
  projects: (id) => [...affiliateLinkDetailsKeys.all, "projects", id],
  giftProjects: (id) => [...affiliateLinkDetailsKeys.all, "gift-projects", id],
  classifications: (id) => [
    ...affiliateLinkDetailsKeys.all,
    "classifications",
    id,
  ],
  landingPages: (id) => [...affiliateLinkDetailsKeys.all, "landing-pages", id],
};
